{
    "userProfile": {
        "title": "Мій профіль",
        "menu": {
            "profile": "Мої дані",
            "companies": "Мої компанії",
            "invoices": "Рахунки"
        },
        "personalData": {
            "title": "Персональні дані"
        },
        "companyData": {
            "title": "Дані компанії"
        },
        "update": {
            "success": {
                "message": "Ваш профіль успішно оновлено"
            },
            "error": {
                "message": "Виникла проблема під час оновлення вашого профілю. Будь ласка, спробуйте ще раз."
            }
        }
    },
    "myCompanies": {
        "title": "Мої компанії",
        "buttons": {
            "addCompany": "Додати компанію"
        },
        "table": {
            "companyNameColumn": "Назва компанії",
            "countryCodeColumn": "Код країни",
            "addressColumn": "Адреса",
            "zipColumn": "Індекс",
            "cityColumn": "Місто",
            "statusColumn": "Статус",
            "tinColumn": "ІПН / VAT"
        }
    },
    "addressBook": {
        "title": "Адресна книга",
        "buttons": {
            "addNewContact": "Додати новий контакт"
        },
        "table": {
            "countryColumn": "Назва країни",
            "companyColumn": "Назва компанії",
            "contactColumn": "Контактна особа",
            "phoneNumberColumn": "Номер телефону",
            "emailColumn": "Електронна адреса"
        }
    },
    "myOrders": {
        "title": "Мої замовлення",
        "buttons": {
            "addNewOrder": "Додати нове замовлення"
        },
        "status": {
            "processing": "В обробці",
            "confirmed": "Підтверджений",
            "scheduledLoading": "Навантаження заплановане",
            "loaded": "Завантажений",
            "inTransit": "У транзиті",
            "customsRegistration": "Митне оформлення",
            "delivered": "Доставлено",
            "cancelled": "Скасовано"
        },
        "table": {
            "orderColumn": "Замовлення",
            "dataColumn": "Дата",
            "senderColumn": "Відправник",
            "recipientColumn": "Одержувач",
            "routeColumn": "Маршрут",
            "uploadDateColumn": "Дата завантаження",
            "deliveryDateColumn": "Дата доставки",
            "statusColumn": "Статус"
        }
    },
    "selectedOrder": {
        "title": "Замовлення",
        "menu": {
            "order": "Замовлення",
            "documents": "Документи",
            "invoices": "Рахунки"
        }
    },
    "orderStatusPanel": {
        "title": {
            "summary": "Підсумок"
        },
        "columns": {
            "creationDate": "Дата створення"
        }
    },
    "documents": {
        "title": "Документи",
        "table": {
            "fileNameColumn": "Назва файлу",
            "typeColumn": "Тип",
            "documentNumberColumn": "Номер документа",
            "orderNumberColumn": "Номер замовлення",
            "documentDateColumn": "Дата документа",
            "createdColumn": "Створено",
            "fileSizeColumn": "Розмір файлу",
            "actionsColumn": "Дії"
        },
        "buttons": {
            "uploadDocument": "Завантажити документ"
        }
    },
    "invoices": {
        "title": "Рахунки",
        "status": {
            "unpaid": "Не оплачено",
            "partiallyPaid": "Частково оплачено",
            "paid": "Оплачено",
            "cancelled": "Скасовано"
        },
        "table": {
            "invoiceNumberColumn": "Номер рахунку",
            "orderNumberColumn": "Номер замовлення",
            "sellerColumn": "Продавець",
            "invoiceDateColumn": "Дата рахунку",
            "dueDateColumn": "Дата оплати",
            "amountColumn": "Сума",
            "amountPaidColumn": "Сплачена сума",
            "statusColumn": "Статус",
            "fileSizeColumn": "Розмір файлу",
            "actionsColumn": "Дії"
        },
        "buttons": {
            "uploadInvoice": "Завантажити рахунок"
        }
    },
    "support": {
        "title": "Допомога та контакти",
        "contact": {
            "title": "Зв'яжіться з нами",
            "button": "Контактна форма",
            "approxOneHour": "прибл. 1 година",
            "approxFiveMinutes": "прибл. 5 хвилин",
            "liveChat": "Онлайн-чат",
            "highCapacityNote": "Приблизно 15 хвилин - наразі висока завантаженість",
            "averageResponseNote": "* Середній час відповіді"
        },
        "solution": {
            "title": "Налаштуйте своє відправлення самостійно",
            "button": "До Центру рішень"
        }
    },
    "notifications": {
        "title": "Сповіщення",
        "createdAt": "Дата створення",
        "subject": "Тема повідомлення",
        "noNotifications": "У вас немає сповіщень",
        "markAllAsRead": "Позначити всі як прочитані",
        "tabs": {
            "all": "Всі",
            "news": "Новини",
            "system": "Системні",
            "service": "Сервісні"
        },
        "drawer": {
            "title": "Сповіщення"
        },
        "unreadCount": "{{count}} нових"
    },
    "adminPanel": {
        "title": "Адмін панель",
        "tabs": {
            "changeRequests": "Запити на зміни",
            "notifications": "Сповіщення",
            "exchangeRates": "Курси валют",
            "tariffUploader": "Завантаження тарифів",
            "tariffSurcharges": "Надбавки тарифів",
            "proposals": "Пропозиції",
            "orders": "Замовлення",
            "allDocuments": "Документи",
            "allInvoices": "Рахунки",
            "users": "Користувачі"
        },
        "users": {
            "search": "Пошук користувачів",
            "table": {
                "name": "Ім'я",
                "email": "Електронна пошта",
                "roles": "Ролі",
                "emailConfirmed": "Пошту підтверджено",
                "status": "Статус",
                "actions": "Дії"
            },
            "status": {
                "active": "Активний",
                "inactive": "Неактивний"
            },
            "values": {
                "yes": "Так",
                "no": "Ні"
            },
            "filters": {
                "allStatuses": "Усі статуси",
                "allRoles": "Усі ролі",
                "allConfirmations": "Усі стани пошти",
                "confirmed": "Підтверджено",
                "unconfirmed": "Не підтверджено"
            },
            "actions": {
                "edit": "Редагувати користувача",
                "activate": "Активувати",
                "deactivate": "Деактивувати"
            },
            "edit": {
                "title": "Редагувати користувача",
                "firstName": "Ім'я",
                "lastName": "Прізвище",
                "email": "Електронна пошта",
                "phone": "Телефон",
                "protectedAdministrator": "Дані іншого адміністратора може редагувати лише власник цього облікового запису."
            },
            "details": {
                "publicId": "Публічний ID",
                "userName": "Ім'я користувача",
                "roles": "Ролі",
                "emailConfirmed": "Пошту підтверджено",
                "phoneConfirmed": "Телефон підтверджено",
                "twoFactor": "Двофакторна автентифікація"
            },
            "statusModal": {
                "activateTitle": "Активувати користувача",
                "deactivateTitle": "Деактивувати користувача",
                "activateMessage": "Активувати {{user}}? Користувач знову зможе увійти.",
                "deactivateMessage": "Деактивувати {{user}}? Поточні сесії буде негайно анульовано.",
                "reason": "Причина (необов'язково)"
            },
            "errors": {
                "user-management": {
                    "self-deactivation": "Ви не можете деактивувати власний обліковий запис.",
                    "self-demotion": "Ви не можете видалити власну роль адміністратора.",
                    "last-active-administrator": "Останнього активного адміністратора не можна деактивувати або позбавити ролі.",
                    "concurrency-conflict": "Інший адміністратор змінив ці дані. Оновіть їх і повторіть спробу."
                },
                "forbidden": "У вас немає дозволу керувати користувачами.",
                "generic": "Не вдалося оновити користувача. Спробуйте ще раз."
            }
        },
        "tariffUploader": {
            "missingDirections": {
                "title": "Деякі маршрути пропущено через відсутні тарифні дані",
                "chain": "Маршрут {{departure}}–{{destination}} «{{title}}» пропущено. Немає тарифних даних для: {{directions}}."
            }
        },
        "allDocuments": {
            "filterByType": "Тип документа",
            "allTypes": "Усі типи",
            "editDocument": "Редагувати документ",
            "deleteConfirm": "Ви впевнені, що хочете видалити цей документ? Це призведе до безповоротного видалення файлу.",
            "table": {
                "orderNumber": "Замовлення",
                "client": "Клієнт",
                "fileName": "Назва файлу",
                "type": "Тип",
                "documentNumber": "Номер документа",
                "documentDate": "Дата документа",
                "created": "Завантажено",
                "fileSize": "Розмір"
            }
        },
        "allInvoices": {
            "filterByStatus": "Статус",
            "statuses": {
                "all": "Усі статуси",
                "unpaid": "Не сплачено",
                "partiallyPaid": "Частково сплачено",
                "paid": "Сплачено",
                "cancelled": "Скасовано"
            },
            "editInvoice": "Редагувати рахунок",
            "deleteConfirm": "Ви впевнені, що хочете видалити цей рахунок? Це призведе до безповоротного видалення файлу.",
            "table": {
                "orderNumber": "Замовлення",
                "client": "Клієнт",
                "invoiceNumber": "Номер рахунку",
                "seller": "Продавець",
                "invoiceDate": "Дата рахунку",
                "dueDate": "Термін оплати",
                "amount": "Сума",
                "amountPaid": "Сплачено",
                "status": "Статус"
            }
        },
        "tariffSurcharges": {
            "subTabs": {
                "definitions": "Надбавки",
                "tariffTypes": "Надбавки за типом тарифу",
                "selected": "Опціональні надбавки"
            },
            "form": {
                "unit": "Одиниця",
                "unitEur": "€ (фіксована сума)",
                "unitPct": "% (відсоток)",
                "amount": "Сума"
            },
            "tariffTypes": {
                "create": "Додати надбавку за типом тарифу",
                "edit": "Редагувати надбавку за типом тарифу",
                "deleteConfirm": "Ви впевнені, що хочете видалити цю надбавку за типом тарифу?",
                "table": {
                    "type": "Тип тарифу",
                    "description": "Опис",
                    "amount": "Сума"
                }
            },
            "selected": {
                "create": "Додати опціональну надбавку",
                "edit": "Редагувати опціональну надбавку",
                "deleteConfirm": "Ви впевнені, що хочете видалити цю опціональну надбавку?",
                "table": {
                    "alias": "Назва",
                    "description": "Опис",
                    "amount": "Сума"
                }
            },
            "definitions": {
                "create": "Додати надбавку",
                "edit": "Редагувати надбавку",
                "deleteConfirm": "Ви впевнені, що хочете видалити цю надбавку? Усі її значення за напрямками буде видалено.",
                "saveToAddDirections": "Збережіть, щоб додати значення за напрямками",
                "directionAmountsTitle": "Значення за напрямками",
                "directionAmountsHint": "Виберіть напрямки нижче та вкажіть суму для кожного окремо. За потреби введіть значення та натисніть «Застосувати», щоб задати його одразу для всіх вибраних напрямків.",
                "directionsSearchPlaceholder": "Пошук напрямків...",
                "selectDirections": "Виберіть напрямки",
                "selectAllVisible": "Вибрати всі видимі",
                "clearSelection": "Очистити вибір",
                "selectedCount": "Вибрано: {{count}}",
                "selectedDirectionsTitle": "Вибрані напрямки",
                "amountNotSet": "суму не задано",
                "noDirections": "Напрямків не знайдено",
                "selectDirectionsError": "Виберіть принаймні один напрямок",
                "emptyAmountsError": "Вкажіть суму для кожного вибраного напрямку перед збереженням.",
                "dimensionAmountsTitle": "Суми з габаритами",
                "dimensionAmountsHint": "Ці рядки застосовуються, лише коли вантаж перевищує вказані пороги. Габарити фіксовані; можна змінювати напрямок та суму.",
                "dimensionLabel": "Д {{length}} × Ш {{width}} × В {{height}} мм, {{weight}} кг",
                "bulkAmountLabel": "Застосувати суму до всіх вибраних ({{symbol}})",
                "applyToSelected": "Застосувати",
                "resetChanges": "Скинути",
                "unsavedChanges": "Є незбережені зміни. Збережіть, щоб застосувати, або скиньте, щоб скасувати.",
                "noAmounts": "Значень за напрямками ще немає",
                "table": {
                    "alias": "Назва",
                    "description": "Опис",
                    "unit": "Одиниця",
                    "amount": "Сума",
                    "directionsCount": "Напрямки",
                    "directionsEmpty": "Не налаштовано",
                    "directionsPopoverTitle": "Суми за напрямками"
                }
            }
        },
        "notifications": {
            "title": "Управління сповіщеннями",
            "createNotification": "Створити сповіщення",
            "editNotification": "Редагувати сповіщення",
            "deleteConfirm": "Ви впевнені, що хочете видалити це сповіщення?",
            "form": {
                "title": "Заголовок",
                "titlePlaceholder": "Введіть заголовок сповіщення",
                "content": "Зміст",
                "contentPlaceholder": "Введіть зміст сповіщення...",
                "type": "Тип",
                "selectType": "Виберіть тип",
                "targetUser": "Цільовий користувач (необов'язково)",
                "targetUserPlaceholder": "Залиште порожнім для розсилки всім",
                "news": "Новини",
                "system": "Системне",
                "service": "Сервісне",
                "isGlobal": "Глобальне сповіщення",
                "isGlobalDescription": "Показувати всім користувачам незалежно від мови (з фолбеком)",
                "atLeastOneTranslation": "Хоча б одна мова має мати заповнені заголовок та зміст"
            },
            "table": {
                "title": "Заголовок",
                "type": "Тип",
                "targetUser": "Цільовий користувач",
                "broadcast": "Розсилка",
                "createdAt": "Створено",
                "actions": "Дії",
                "languages": "Мови",
                "global": "Глобальне"
            }
        },
        "changeRequests": {
            "title": "Запити на зміни",
            "filterByStatus": "Фільтр за статусом",
            "staleBadge": "Застарілий",
            "statuses": {
                "all": "Всі статуси",
                "pending": "Очікує",
                "approved": "Схвалено",
                "rejected": "Відхилено"
            },
            "table": {
                "orderNumber": "Номер замовлення",
                "user": "Користувач",
                "status": "Статус",
                "changes": "Зміни",
                "requestedAt": "Запитано",
                "view": "Переглянути"
            }
        },
        "rejectModal": {
            "title": "Відхилити запит на зміну",
            "reasonLabel": "Причина відхилення",
            "reasonPlaceholder": "Введіть причину відхилення цього запиту на зміну..."
        },
        "changesSummary": {
            "title": "Запитані зміни",
            "showChanges": "Показати зміни",
            "hideChanges": "Сховати зміни",
            "fields": {
                "deliveryFrom": "Адреса відправника",
                "deliveryTo": "Адреса отримувача",
                "deliveryOption": "Варіант доставки",
                "orderCargo": "Вантаж",
                "recommendedServices": "Додаткові послуги"
            },
            "properties": {
                "countryCode": "Код країни",
                "countryName": "Країна",
                "zip": "Індекс",
                "city": "Місто",
                "address": "Адреса",
                "companyName": "Компанія",
                "contactPerson": "Контактна особа",
                "email": "Електронна пошта",
                "phoneNumber": "Телефон",
                "note": "Примітка",
                "optionType": "Тип опції",
                "loadingDate": "Дата завантаження",
                "deliveryDate": "Дата доставки",
                "totalAmount": "Загальна сума",
                "cargoType": "Тип вантажу",
                "quantity": "Кількість",
                "length": "Довжина",
                "width": "Ширина",
                "height": "Висота",
                "weight": "Вага",
                "optionCode": "Код послуги",
                "cost": "Вартість",
                "amountInput": "Сума",
                "cargoTimeSlot": "Часовий слот"
            },
            "table": {
                "field": "Поле",
                "old": "Було",
                "new": "Стало"
            },
            "status": {
                "added": "Додано",
                "removed": "Видалено",
                "modified": "Змінено"
            }
        },
        "proposals": {
            "table": {
                "proposalColumn": "Пропозиція",
                "dateColumn": "Дата",
                "userColumn": "Користувач",
                "routeColumn": "Маршрут",
                "loadingDateColumn": "Дата завантаження",
                "deliveryDateColumn": "Дата доставки",
                "freightColumn": "Фрахт",
                "statusColumn": "Статус"
            },
            "filterByStatus": "Фільтр за статусом",
            "statuses": {
                "all": "Всі статуси",
                "processing": "В обробці",
                "awaitingConfirmation": "Очікує підтвердження",
                "confirmed": "Підтверджено",
                "cancelled": "Скасовано"
            },
            "buttons": {
                "setPrice": "Встановити ціну"
            },
            "setPriceModal": {
                "title": "Встановити ціну пропозиції",
                "proposalNumberLbl": "Номер пропозиції",
                "deliveryCostLbl": "Вартість доставки (€)",
                "deliveryCostPlaceholder": "Введіть вартість",
                "commentLbl": "Коментар",
                "commentPlaceholder": "Необов'язковий коментар для користувача..."
            }
        },
        "orders": {
            "editOrder": "Редагувати замовлення",
            "confirmSave": "Ви впевнені, що хочете зберегти зміни до цього замовлення?",
            "filterByStatus": "Фільтр за статусом",
            "filterByTariffType": "Фільтр за тарифом",
            "filterByLoadingType": "Фільтр за типом завантаження",
            "table": {
                "orderNumber": "Номер замовлення",
                "user": "Користувач",
                "date": "Дата",
                "sender": "Відправник",
                "recipient": "Отримувач",
                "route": "Маршрут",
                "loadingDate": "Дата завантаження",
                "deliveryDate": "Дата доставки",
                "tariffType": "Тариф",
                "totalAmount": "Сума",
                "loadingType": "Завантаження",
                "status": "Статус",
                "companyPayer": "Платник"
            },
            "statuses": {
                "all": "Всі статуси",
                "processing": "В обробці",
                "confirmed": "Підтверджено",
                "scheduledLoading": "Заплановане завантаження",
                "loaded": "Завантажено",
                "inTransit": "В дорозі",
                "customsRegistration": "Митне оформлення",
                "delivered": "Доставлено",
                "cancelled": "Скасовано"
            },
            "tariffTypes": {
                "all": "Всі тарифи",
                "standard": "Стандарт",
                "premium": "Преміум",
                "individual": "Індивідуальний"
            },
            "loadingTypes": {
                "all": "Всі типи завантаження",
                "partial": "Збірний",
                "full": "Повний"
            },
            "cargoTypes": {
                "cardboardBox": "Картонна коробка",
                "euroPallet": "Євро палета",
                "palletFin": "Палета FIN",
                "palletInd": "Палета IND",
                "other": "Інше"
            },
            "bodyTypes": {
                "bus": "Автобус",
                "tent": "Тент",
                "tentCurtain": "Тент-штора",
                "isotherm": "Ізотерм",
                "refrigerator": "Рефрижератор",
                "flatbed": "Бортовий",
                "flatbedTent": "Бортовий з тентом",
                "containerCarrier": "Контейнеровоз",
                "dumpTruck": "Самоскид",
                "fullMetalVan": "Цільнометалевий фургон",
                "mega": "Мега"
            },
            "loadingMethods": {
                "rear": "Задній",
                "side": "Боковий",
                "top": "Верхній"
            },
            "form": {
                "status": "Статус",
                "deliveryOption": "Варіант доставки",
                "tariffType": "Тип тарифу",
                "totalAmount": "Загальна сума (€)",
                "loadingDate": "Дата завантаження",
                "deliveryDate": "Дата доставки",
                "deliveryFrom": "Адреса відправника",
                "deliveryTo": "Адреса отримувача",
                "countryCode": "Код країни",
                "countryName": "Країна",
                "zip": "Індекс",
                "city": "Місто",
                "address": "Адреса",
                "companyName": "Компанія",
                "contactPerson": "Контактна особа",
                "email": "Електронна пошта",
                "phoneNumber": "Телефон",
                "note": "Примітка",
                "cargo": "Вантаж",
                "loadingType": "Тип завантаження",
                "cargoType": "Тип вантажу",
                "quantity": "Кількість",
                "length": "Довжина",
                "width": "Ширина",
                "height": "Висота",
                "weight": "Вага",
                "bodyType": "Тип кузова",
                "loadingMethod": "Спосіб завантаження",
                "carryingCapacity": "Вантажопідйомність",
                "loadingMetersLdm": "Завантажувальні метри (LDM)",
                "cargoAdditional": "Додаткова інформація про вантаж",
                "loadingWithTailLift": "Завантаження з гідробортом",
                "adrDangerousGoods": "ADR небезпечні вантажі",
                "cargoDescription": "Опис вантажу",
                "costOfCargo": "Вартість вантажу",
                "costOfCargoCurrency": "Валюта",
                "addRecommendedService": "Додати послугу",
                "noServices": "Додаткові послуги відсутні"
            }
        }
    },
    "mySuggestions": {
        "title": "Мої пропозиції",
        "table": {
            "proposalColumn": "Пропозиція",
            "dateColumn": "Дата",
            "routeColumn": "Маршрут",
            "loadingDateColumn": "Дата завантаження",
            "deliveryDateColumn": "Дата доставки",
            "freightColumn": "Фрахт",
            "additionalServicesColumn": "Додаткові послуги",
            "totalColumn": "Загальна вартість",
            "statusColumn": "Статус"
        },
        "buttons": {
            "confirm": "Підтвердити",
            "cancel": "Скасувати",
            "newRequest": "Новий запит"
        },
        "status": {
            "processing": "В обробці",
            "awaitingConfirmation": "Очікує підтвердження",
            "confirmed": "Підтверджено",
            "cancelled": "Скасовано"
        }
    }
}